export const chainId = 43114;
export const chainIdHex = `0x${chainId.toString(16)}`;

export const rpcUrl = "https://api.avax.network/ext/bc/C/rpc";

export const avaxfuAddress = "0xDec9d62e3B8CD3321731BF2418b6f455a05C610A";
